import { createFileRoute } from '@tanstack/react-router';

import { SportsAndProductNaturesServiceLinkage } from '../../components/ServiceLinkage/SportsAndProductNaturesServiceLinkage';

export const Route = createFileRoute('/_auth/associated-services/')({
  component: SportsAndProductNaturesServiceLinkage,
});
